import { useContext } from 'react';
import { ELSIdleProvider } from '@els/els-ui-common-react';
import { useHistory } from 'react-router';
import { AppConstants, RoutePath } from './app.constants';
import { AppContext } from './AppProvider.component';
import { getRefreshToken } from '../../utilities/refresh-token.utilities';
import { rotateRefreshTokenOrTimeout } from './AppRegistrar.utilities';
import { notifyParentOfSessionExpired } from './app-session.utilities';
import { trackNewRelicAction } from './app-state-actions.utilities';
import { NewRelicAnalyticsAction } from '../../models/new-relic-analytics.models';

export type IdleHandlerProps = {
  history: ReturnType<typeof useHistory>;
};

const IdleHandler = ({ history }: IdleHandlerProps): JSX.Element => {
  const { setAppState, appStateRef } = useContext(AppContext);

  return (
    <ELSIdleProvider
      timeout={AppConstants.IDLE_TIMEOUT}
      onSessionTimeout={() => {
        const refreshToken = getRefreshToken();
        if (refreshToken) {
          rotateRefreshTokenOrTimeout(refreshToken, { setAppState, appStateRef, history });
        } else {
          trackNewRelicAction({
            appStateRef,
            actionProps: { action: NewRelicAnalyticsAction.IDLE_SESSION_TIMEOUT_NO_REFRESH_TOKEN, props: null }
          });
          notifyParentOfSessionExpired();
          history.push(RoutePath.TIMEOUT);
        }
      }}
    />
  );
};

export default IdleHandler;
